var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Alert, Button, Container, Snackbar, useMediaQuery, useTheme } from '@mui/material';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { setChatMachineToken, setMapboxAccessToken, setSpeechKey, setTranslationKey, setVisionKey } from '../../application/features/auth/authSlice';
import { MachineStatus } from '../../application/features/chat-machine/machine-status';
import { useLazyKeepAliveQuery } from '../../application/features/chat/chat-api';
import { getServiceToken } from '../../application/features/common/get-service-token';
import { DocumentUploadingStatus } from '../../application/features/machine-documents/enums/document-uploading-status';
import { setDocumentUploading } from '../../application/features/machine-documents/machine-documentSlice';
import { useAppDispatch, useAppSelector } from '../../application/store/useStore';
import useTranslate from '../../localization/helpers';
import Header from './header';
import './styles.scss';
var Layout = function () {
    var theme = useTheme();
    var _a = useTranslate(), translate = _a.translate, tWithField = _a.tWithField;
    var dispatch = useAppDispatch();
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var authState = useAppSelector(function (state) { return state.auth; });
    var isMobile = useMediaQuery(theme.breakpoints.only('xs'));
    var isIpad = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
    var isIpadMini = useMediaQuery('(min-width: 600px) and (max-width: 768px)');
    var uploading = useAppSelector(function (state) { return state.machineDocument; }).uploading;
    var _b = useAppSelector(function (state) { return state.common; }), chatMachineStatus = _b.chatMachineStatus, chatApiStatus = _b.chatApiStatus;
    var showAiErrorSnackBar = chatMachineStatus === 'error' || chatApiStatus === 'error';
    var _c = __read(useLazyKeepAliveQuery(), 1), triggerKeepAlive = _c[0];
    var _d = __read(useState(true), 2), sidebarCollapsed = _d[0], setSidebarCollapsed = _d[1];
    var _e = __read(useState(false), 2), hovering = _e[0], setHovering = _e[1];
    var MACHINE_ENDPOINT = process.env.REACT_APP_CHAT_MACHINE_ENDPOINT;
    useEffect(function () {
        if (MACHINE_ENDPOINT && (!authState.chatMachineToken || authState.chatMachineToken === null)) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var token;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getServiceToken(dispatch, 'ChatMachineToken')];
                        case 1:
                            token = _a.sent();
                            dispatch(setChatMachineToken(token));
                            return [4 /*yield*/, MachineStatus(dispatch)];
                        case 2:
                            _a.sent();
                            triggerKeepAlive();
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
        else if (MACHINE_ENDPOINT &&
            (authState.chatMachineToken || authState.chatMachineToken !== null)) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MachineStatus(dispatch)];
                        case 1:
                            _a.sent();
                            triggerKeepAlive();
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [MACHINE_ENDPOINT]);
    useEffect(function () {
        if (uploading === DocumentUploadingStatus.Uploading) {
            enqueueSnackbar(translate('toolTips.uploadingDocuments'), {
                key: 'uploading',
                persist: true,
                variant: 'info',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        }
        else if (uploading === DocumentUploadingStatus.Uploaded) {
            closeSnackbar('uploading');
            enqueueSnackbar(tWithField('toolTips.addSuccess', 'common.document(s)'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            dispatch(setDocumentUploading(DocumentUploadingStatus.Uninitialized));
        }
        else if (uploading === DocumentUploadingStatus.Error) {
            closeSnackbar('uploading');
            enqueueSnackbar(translate('toolTips.uploadDocumentFailure'), {
                autoHideDuration: 3000,
                variant: 'error',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            dispatch(setDocumentUploading(DocumentUploadingStatus.Uninitialized));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploading]);
    useEffect(function () {
        var tokenConfigs = [
            {
                key: 'speechKey',
                action: setSpeechKey,
                service: 'SpeechKey'
            },
            {
                key: 'translationKey',
                action: setTranslationKey,
                service: 'TranslationKey'
            },
            {
                key: 'visionKey',
                action: setVisionKey,
                service: 'VisionKey'
            },
            {
                key: 'mapboxAccessToken',
                action: setMapboxAccessToken,
                service: 'MapboxAccessToken'
            }
        ];
        tokenConfigs.forEach(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var token;
            var key = _b.key, action = _b.action, service = _b.service;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (authState[key])
                            return [2 /*return*/];
                        return [4 /*yield*/, getServiceToken(dispatch, service)];
                    case 1:
                        token = _c.sent();
                        dispatch(action(token));
                        return [2 /*return*/];
                }
            });
        }); });
    }, [authState, dispatch]);
    var handleSidebarCollapse = function (isCollapsed) {
        setSidebarCollapsed(isCollapsed);
        setHovering(false);
    };
    return (_jsxs("main", { className: "layout-main".concat(isMobile ? '' : isIpad ? '' : isIpadMini ? '' : sidebarCollapsed ? 'full' : hovering ? 'hover' : ''), children: [_jsx(Header, { onSidebarToggle: handleSidebarCollapse }), _jsx(Container, { sx: {
                    mt: __assign(__assign({ xs: '66px' }, (isscreen600900 && { sm: '80px' })), (isscreen600900Landscape && { sm: '64px' })),
                    pl: { xs: 0, sm: '0px', lg: '24px' },
                    pr: { xs: 0, sm: '0px', lg: '24px' }
                }, maxWidth: false, children: _jsx(Outlet, {}) }), _jsx(Snackbar, { open: showAiErrorSnackBar, sx: { top: '60px !important', '.MuiPaper-root': { alignItems: 'center' } }, anchorOrigin: { vertical: 'top', horizontal: 'center' }, children: _jsxs(Alert, { icon: _jsx(Icon, { icon: 'typcn:warning-outline' }), variant: 'filled', severity: 'error', sx: {
                        width: '100%',
                        '& .MuiAlert-message': {
                            display: 'flex',
                            overflowX: 'clip',
                            alignItems: 'center',
                            whiteSpace: isIpad ? 'nowrap' : 'normal'
                        }
                    }, children: [translate('toolTips.aiEngineStartupFailure'), _jsx(Button, { size: 'small', variant: 'outlined', sx: { ml: 1 }, color: 'inherit', onClick: function () { return window.location.reload(); }, children: translate('actions.refresh') })] }) })] }));
};
export default Layout;
